import { uniq } from 'es-toolkit';
import React, { ReactNode } from 'react';
import { SxProps, Theme } from '@mui/material';

import { INDETERMINATE } from '@paragon/client-tools';
import { NumericField } from '@paragon/material';

interface Props {
  readonly sx?: SxProps<Theme>;
  readonly values: readonly number[];
  readonly submit: (newValue: number) => void;
  readonly label: ReactNode;
  readonly unit?: string;
  readonly disabled?: boolean;
  readonly numberOfDecimals?: number;
  readonly min?: number;
  readonly max?: number;
  readonly integers?: boolean;
}

export function MultiValueNumberInput(props: Props) {
  const numberOfDecimals = props.numberOfDecimals ?? 2;

  const uniqueValues = uniq(props.values);
  const value = uniqueValues.length === 1 ? uniqueValues[0] : INDETERMINATE;

  return (
    <NumericField
      canBeIndeterminate
      sx={props.sx}
      label={props.label}
      value={value}
      onSubmit={props.submit}
      min={props.min}
      max={props.max}
      integers={props.integers}
      numberOfDecimals={numberOfDecimals}
      endAdornment={props.unit}
      disabled={props.disabled}
      fullWidth={false}
    />
  );
}
